export const environment = {
  production: import.meta.env.PROD,
};
